export default __webpack_public_path__ + "images/loans-coins.bf508011daf3e3596e800567f18056ff.png";